import React from "react";
import type { Recipe } from "../../types/Recipe";
import { useUser } from "../../context/UserContext";

interface Props {
  recipes: Recipe[];
  onDelete: (id: number) => void;
  setModalRecipeId: (id: number) => void;
}

const RecipeList: React.FC<Props> = ({
  recipes = [],
  onDelete,
  setModalRecipeId,
}) => {
  const { user } = useUser();

  const canDeleteRecipe = user?.roles?.some((r) =>
    ["MenuResponsible"].includes(r),
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      {Array.isArray(recipes) &&
        recipes.map((r) => (
          <div
            key={r.id}
            className="
              bg-white/90 backdrop-blur-md rounded-2xl shadow-md overflow-hidden 
              border border-orange-100 hover:shadow-lg transition cursor-pointer
            "
            onClick={() => setModalRecipeId(r.id)}
          >
            {/* Image */}
            <div className="h-40 min-h-[200px] w-full overflow-hidden bg-gray-100 flex items-center justify-center">
              <img
                src={r.imageUrl || "/assets/no-image-placeholder.webp"}
                alt={r.title}
                className="max-h-full max-w-full object-contain transition-transform duration-300 group-hover:scale-105"
              />
            </div>

            {/* Content */}
            <div className="p-4 flex flex-col gap-2">
              <h3 className="font-semibold text-orangeBrand text-lg leading-snug">
                {r.title}
              </h3>

              <p className="text-sm text-gray-700 line-clamp-2">
                {r.description}
              </p>

              {/* Delete button */}
              {canDeleteRecipe && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(r.id);
                  }}
                  className="
                    mt-2 self-end px-3 py-1.5 rounded-full
                    bg-red-500/90 text-white text-sm
                    hover:bg-red-600 transition
                  "
                >
                  🗑️ Fjern
                </button>
              )}
            </div>
          </div>
        ))}
    </div>
  );
};

export default RecipeList;
